// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/views/partner/crud/viewFixtureScreen/viewfixturescreen.css
// module id = 2670
// module chunks = 0